export default __webpack_public_path__ + "static/media/tavi_main_mobile_small@2x.8f787999.jpg";